import styled from 'styled-components';

import { media } from '../../styles/constants';

const TextCircle = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    z-index: -1;
    width: 42rem;
    height: 42rem;

      @media (min-width: ${media.tabletPortrait}) {
        width: 36rem;
        height: 36rem;
        top: 0;
      }

      @media (min-width: ${media.tabletLandscape}) {
        width: 40rem;
        height: 40rem;
      }

      @media (min-width: ${media.desktop}) {
        width: 45rem;
        height: 45rem;
      }

      img,
      svg {
        margin-top: 1.5rem;
        max-width: 15rem;
        max-height: 10rem;
      }
    }
  }

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.2rem;
    line-height: 3rem;
    max-width: 39rem;

    @media (min-width: ${media.tabletPortrait}) {
      height: 36rem;
      font-size: 3rem;
      line-height: 3.9rem;
      margin-left: -3rem;
      margin-right: -2rem;
      margin-bottom: auto;
      max-width: 33rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      height: 41rem;
      font-size: 3.4rem;
      line-height: 4.5rem;
      max-width: 37rem;
    }

    @media (min-width: ${media.desktop}) {
      height: 45rem;
      max-width: 42rem;
    }
  }

  @media (min-width: ${media.tabletPortrait}) {
    align-items: unset;
  }
`;

export default TextCircle;
